import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import MFSipOrderBookReducer from "./mfSipOrderBook";
export default combineReducers({
    reducersData: MFSipOrderBookReducer,
    commonData: commonReducer,
});
